import React from "react";
import "./LongList.scss";
import LongListItem from "./LongListItem";

export default function LongList({phase, program, history, pagetype, items, removeItem, from }) {
  // console.log("phaseee",phase)
  return (
    <div className="c-longlist-list">
      {
        items && items.map((item, idx) => (
          <LongListItem key={idx} history={history} program={program} phase={phase} pagetype={pagetype} item={item} idx={idx} removeItem={removeItem} from={from} />
        ))
      }
    </div>
  );
}
